





















import _ from 'lodash'
import { Component, Prop } from 'vue-property-decorator'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import ScheduleDetail from '@/components/today/ScheduleDetail.vue'
import PatientDetail from '@/components/today/PatientDetail.vue'
import { ISchedule, ITimeline } from '@/store/modules/views/schedule/states'
import MainLog from '@/components/logs/MainLog.vue'
import { IJob } from '@/store/modules/views/job/states'
import { IPatient } from '@/store/modules/views/patient/states'

@Component({
  components: {
    ScheduleDetail,
    PatientDetail,
    MainLog,
  },
})
export default class LogTemplate extends VueExtendedBaseComponent {
  @Prop({ default: '' }) public header!: string
  @Prop() public job!: IJob
  @Prop({ default: () => ({})}) public patient!: IPatient
  @Prop({ default: []}) public schedules!: ISchedule[]
  @Prop() public detail!: ITimeline
}
